async function fetchProduct(handle) {
  try {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error('Product fetch failed');
    return await res.json();
  } catch (e) {
    console.warn('fetchProduct error', e);
    return null;
  }
}

async function enrichCartWithComparePrices(cart) {
  if (!cart || !cart.items) return cart;

  for (let i = 0; i < cart.items.length; i++) {
    const item = cart.items[i];

    if (item.compare_at_price !== undefined || !item.handle || !item.variant_id) continue;

    const product = await fetchProduct(item.handle);
    if (!product || !product.variants) continue;

    const variant = product.variants.find(v => Number(v.id) === Number(item.variant_id));
    if (variant && variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
      item.compare_at_price = variant.compare_at_price;
    } else {
      item.compare_at_price = null;
    }
  }

  return cart;
}

function dispatchCartEnhancedEvent(cart) {
  const event = new CustomEvent('cart:enhanced', { detail: { cart } });
  window.dispatchEvent(event);
}

window.cartEnhance = {
  enrichCartWithComparePrices,
  dispatchCartEnhancedEvent
};
